import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Portfolio from "@/pages/Portfolio";
import Studio from "./pages/Studio";
import Pricing from "@/pages/Pricing";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Creations from "@/pages/Creations";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App grain bg-[#0A0A0C] min-h-screen">
      <AuthProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/a-propos" element={<About />} />
<Route path="/studio" element={<Studio />} />
            <Route path="/tarifs" element={<Pricing />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/creations" element={<Creations />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/tableau" element={<AdminDashboard />} />
          </Routes>
          <Footer />
          <Toaster theme="dark" position="bottom-right" toastOptions={{
            style: { background: "#121216", border: "1px solid rgba(212,175,55,0.3)", color: "#F8F9FA" },
          }} />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
